/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { InvertersApi } from '../api/inverters.api';
import { InvertersData, InvertersValue, ActivePowerValue } from '../../../interfaces/solar/inverters';

@Injectable()
export class InvertersService extends InvertersData {

  // private data: InvertersValue[] = [
  //   {
  //     dt: '2019-12-19T08:25:00.000Z',
  //     PVTemp: 8.6,
  //     AmpTemp: 8.3,
  //     Radiation: 557,
  //   },
  // ];

  constructor(private api: InvertersApi) {
    super();
  }

  getInverterTodayData(params): Observable<InvertersValue[]> {
    return this.api.getInverterTodayData(params);
  }

  // Pac - Active Power
  getTodayInvertersPacByKtpNum(params): Observable<InvertersValue[]> {
    return this.api.getTodayInvertersPacByKtpNum(params);
  }

  // Qac - Reactive Power
  getTodayInvertersQacByKtpNum(params): Observable<InvertersValue[]> {
    return this.api.getTodayInvertersQacByKtpNum(params);
  }

  // Current Power
  getCurrentPower(params): Observable<string> {
    return this.api.getCurrentPower(params);
  }

  getDailyEnergy(params): Observable<string> {
    return this.api.getDailyEnergy(params);
  }

  // Array of day PV Power
  getDayPowerValues(params): Observable<ActivePowerValue[]> {
    return this.api.getDayPowerValues(params);
  }

  // Array of day SOLING Power
  getDaySolingPowerValues(params): Observable<ActivePowerValue[]> {
    return this.api.getDaySolingPowerValues(params);
  }


  getEnergyByDate(params): Observable<any> {
    return this.api.getEnergyByDate(params)
  } 
  // list(): Observable<Facility[]> {
  //   // return this.api.list();
  //   return observableOf(this.data);
  // }
}
